module.exports = __webpack_public_path__ + "static/media/smallgroup.6e22af91.svg";